import { all, call, fork, put, takeLeading } from 'redux-saga/effects'
import { getTotalItemsCount_api } from 'store/apis'
import { setTotalItemsCount_action } from 'store/actions'
import * as types from 'store/types'

function* getTotalItemsCount_saga() {
  try {
    const result = yield call(getTotalItemsCount_api)
    yield put(setTotalItemsCount_action(result))
  } catch (error) {}
}

function* watchSagas() {
  yield takeLeading(types.GET_TOTALITEMS, getTotalItemsCount_saga)
}

export default function* appSagas() {
  yield all([fork(watchSagas)])
}
